import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SadColoredSvg } from './assets/sad-colored.svg';

const SadColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={SadColoredSvg} ref={ref} {...args} />);

export default SadColoredIcon;
